import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { BpListGroupDirective, BpListGroupItemDirective } from './list-group';

const DECLARES = [
  BpListGroupDirective,
  BpListGroupItemDirective
];

@NgModule({
  imports: [
    CommonModule
  ],
  declarations: DECLARES,
  exports: DECLARES
})
export class BpListGroupModule {
}
